var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"input",staticClass:"inline-block",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"loading":_vm.inputOnly},on:{"change":v => _vm.$emit('change', v),"input":_vm.handleInput},scopedSlots:_vm._u([(_vm.inputOnly)?{key:"progress",fn:function(){return [_c('div')]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }